export default "__VITE_ASSET__jjqgF0cW__"